<template>
<div>
     <pt-sub-title title="用户信息"></pt-sub-title>
     <table class="message-table">
         <pt-message-table-item label="用户名">{{data.fullName}}</pt-message-table-item>
         <pt-message-table-item label="手机号">{{data.mobile}}</pt-message-table-item>
         <pt-message-table-item label="用户等级">{{data.memberLevelName}}</pt-message-table-item>
         <pt-message-table-item label="CPS所在地">{{data.city}}</pt-message-table-item>
     </table>
     <el-button class="message-button-div" type="primary" @click="getCustomerDetail">用户详情</el-button>
</div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getCustomerDetail () {
      this.$router.push(`/all-customer/customer-detail/${this.data.id}`)
    }
  }
}
</script>
<style module lang="less">

</style>
